import { drawerStore } from 'ats/components/drawer/DrawerStore';
import ApplicantProfile from 'ats/pages/applicants/ApplicantProfile';
import ClientProfile from 'ats/pages/clients/ClientProfile';
import JobPositionProfile from 'ats/pages/job-positions/JobPositionProfile';

const PROFILE_CONTAINERS = [
	'applicants',
	'pipeline',
	'job-positions',
	'clients',
	'external-applications'
];

function openProfileDrawer({ drawerId, component, props }) {
	drawerStore.openDrawer(
		{
			containerId: PROFILE_CONTAINERS,
			showHeader: false,
			drawerId,
			props: {
				onClose: () => drawerStore.closeDrawer(),
				...props
			}
		},
		component
	);
}

export function openApplicantProfile(applicantId, extraProps = {}) {
	if (!applicantId) return;

	openProfileDrawer({
		drawerId: drawerStore.DRAWER_IDS.APPLICANT_PROFILE,
		component: ApplicantProfile,
		props: {
			applicantId,
			...extraProps
		}
	});
}

export function openJobPositionProfile(jobPositionId, extraProps = {}) {
	if (!jobPositionId) return;

	openProfileDrawer({
		drawerId: drawerStore.DRAWER_IDS.JOB_POSITION_PROFILE,
		component: JobPositionProfile,
		props: {
			jobPositionId,
			...extraProps
		}
	});
}

export function openClientProfile(clientId, extraProps = {}) {
	if (!clientId) return;

	openProfileDrawer({
		drawerId: drawerStore.DRAWER_IDS.CLIENT_PROFILE,
		component: ClientProfile,
		props: {
			clientId,
			...extraProps
		}
	});
}

export function attachListProfileDrawerHandlers({
	drawerId,
	idKey,
	entityId,
	onClose,
	onSuccess
}) {
	const alreadyOpen =
		drawerStore.isOpen &&
		drawerStore.drawerId === drawerId &&
		String(drawerStore.drawerComponentProps?.[idKey]) === String(entityId);

	if (!alreadyOpen) return false;

	drawerStore.updateDrawerProps({ onClose, onSuccess });
	return true;
}
